import { Link, useLocation } from "react-router-dom";
import MobileSidebar from "./mobile-sidebar";
import { JandiLogo } from "../assets/logos/svgs";

const MobileMenu = () => {
  const { pathname } = useLocation();

  const backgroundStyle =
    pathname === "/"
      ? {
          backgroundColor: "rgba(255,255,255,0.2)",
          backdropFilter: "blur(14px)",
        }
      : {
          backgroundColor: "rgb(255,255,255)",
        };

  return (
    // <!-- Main Header-->
    <header className="main-header main-header-mobile">
      <div className="auto-container" style={backgroundStyle}>
        {/* <!-- Main box --> */}
        <div className="inner-box">
          <div className="nav-outer">
            <div className="logo-box">
              <div className="logo">
                <Link to="/">
                  <JandiLogo style={{ width: "75%" }} />
                </Link>
              </div>
            </div>
            {/* End .logo-box */}

            <MobileSidebar />
            {/* <!-- Main Menu End--> */}
          </div>
          {/* End .nav-outer */}

          <div className="outer-box">
            {/* login popup end */}

            <a
              href="#"
              className="mobile-nav-toggler"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasMenu"
            >
              <span className="fa fa-bars"></span>
            </a>
            {/* right humberger menu */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default MobileMenu;
